<template>
  <div class="edit-workgroup-case-dailog dialog col-block">
    <div class="edit-workgroup-case-title-container col-block width-full">
      <div class="edit-workgroup-case-title-block row-block">
        <div class="edit-workgroup-case-title">{{ $t('DIALOG.editWorkgroupCase.___title') }}</div>
        <div class="edit-workgroup-case-alert"> *</div>
        <div :style="{ width: '10px' }"></div>
        <div class="edit-workgroup-case-info">{{ '(' + $tc('DIALOG.editWorkgroupCase.___info', selectedCaseIDs.length, { count: selectedCaseIDs.length }) + ')' }}</div>
        <div :style="{ width: '10px' }"></div>
        <button class="white-gray-button circle-button" @click="e => addAllCase()">
          <span>{{ $t('COMMON.button.___addAll') }}</span>
        </button>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="edit-workgroup-case-option-container row-block">
      <div class="edit-workgroup-case-search-container input-group" :style="{ width: '478px' }">
        <input type="text" :placeholder="$t('DIALOG.editWorkgroupCase.___searchPlaceholder')" v-model="query" :style="{ 'padding-right': '40px' }">
        <img :src="require('../../assets/images/search-solid.svg')" alt="">
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="custom-table" :class="{ 'auto-height': false }">
      <div
        v-if="tableWidths"
        class="table-field col-block grab-container"
        :style="{ width: tableWidths.reduce((s, c) => s + c.value + c.grab, 0) + 'px' }"
      >
        <div class="table-container col-block">
          <div class="thead">
            <div class="tr row-block">
              <div
                v-for="(option, index) in tableOptions"
                :key="index"
                class="th row-block"
                :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.value)"
              >
                <template v-if="option.value === '_SELECT'">
                  <img
                    class="select-icon"
                    :src="(selectedCaseIDs.concat(caseDataIDs).filter((x, i, s) => s.indexOf(x) === i).length - selectedCaseIDs.length < caseDataIDs.length) ? (selectedCaseIDs.concat(caseDataIDs).filter((x, i, s) => s.indexOf(x) === i).length === selectedCaseIDs.length) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')"
                    @click="e => (selectedCaseIDs = (selectedCaseIDs.concat(caseDataIDs).filter((x, i, s) => s.indexOf(x) === i).length === selectedCaseIDs.length) ? [] : selectedCaseIDs.concat(caseDataIDs).filter((x, i, s) => s.indexOf(x) === i))"
                  >
                </template>
                <template v-else>
                  <span class="ellipsis">{{ option.title }}</span>
                </template>
                <template v-if="option.sortMap !== null">
                  <div :style="{ width: '5px' }"></div>
                  <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div ref="custom-table-scroll" class="table-group-container col-block width-full">
          <div class="col-block">
            <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
              <div class="tbody">
                <div class="tr group row-block" :class="{ selected: false }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                  <a class="container-block row-block">
                    <!-- <div class="bar"></div> -->
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                      :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                    >
                      <template>
                        <span
                          :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                          :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                          v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                        ></span>
                      </template>
                      <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                        <div :style="{ width: '5px' }"></div>
                        <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                      </template>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </a>
                </div>
                <div class="tr col-block" :class="{ selectable: false, selected: false, disabled: disabledCaseIDs.includes(data.id) }" v-for="(data, dindex) in group.datas" :key="dindex">
                  <a class="container-block row-block" :style="{ flex: 1 }" @click="e => {}">
                    <!-- <div class="bar"></div> -->
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="(option.class || (() => []))(data[option.value], dindex, data)"
                      :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                    >
                      <div class="disabled-mask"></div>
                      <template v-if="option.value === '_SELECT'">
                        <borCor
                          :display="disabledCaseIDs.includes(data.id) ? null : false"
                          :background="'white'"
                          :border="'#707070'"
                          :radius="'0px'"
                          :type="'right'"
                          :reverse="true"
                          :blockStyle="{ padding: '6px 8px' }"
                        >
                          <div slot="trigger">
                            <img
                              class="select-icon"
                              :src="(selectedCaseIDs.includes(data.id) || disabledCaseIDs.includes(data.id)) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')"
                              @click="e => (selectedCaseIDs = selectedCaseIDs.includes(data.id) ? selectedCaseIDs.filter(id => id !== data.id) : selectedCaseIDs.concat([data.id]))"
                            >
                          </div>
                          <div class="content col-block" slot="content">
                            <div class="disabled-alert" v-html="$t('DIALOG.editWorkgroupCase.table.alert.___added')"></div>
                          </div>
                        </borCor>
                      </template>
                      <template v-else>
                        <span
                          :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                          :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                          v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                        ></span>
                      </template>
                      <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                        <div :style="{ width: '5px' }"></div>
                        <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                      </template>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-container row-block" :style="{ height: '50px' }">
      <div class="page-info-field row-block">
        <div
          v-if="pageData.total !== null"
          class="page-info-container"
          v-html="$tc('DIALOG.editWorkgroupCase.table.pageDisplay.___item', pageData.total)"
          :style="{ flex: 1 }"
        ></div>
      </div>
      <div class="options-container input-group row-block">
        <pageButtons
          v-if="pageData.total"
          :default="pageData.selectedPage"
          :display="pageData.display - 0"
          :total="pageData.total"
          :buttonRange="pageData.buttonRange"
          @selectPage="page => { pageData.selectedPage = page }"
          :style="{ flex: 1 }"
        ></pageButtons>
        <div :style="{ width: '20px' }"></div>
        <div class="jump-container row-block">
          <div class="jump-title">{{ $t(pageDisplay.page) }}</div>
          <div :style="{ width: '10px' }"></div>
          <select class="jump" v-model="pageData.pageJumpTo" @change="e => pageData.selectedPage = pageData.pageJumpTo - 0">
            <option v-for="(value, index) in (new Array(totalPage)).fill('').map((_, i) => i + 1)" :key="index" :value="value">{{ value }}</option>
          </select>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, { datas: selectedCases })">
        <span>{{ $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getWorkgroupCases } from '../../api'
import pageButtons from '../tool/pageButtons.vue'
import borCor from '../tool/newBorCor.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import responsitive from '../../mixins/responsitive.vue'
import { pageDisplay } from '../../constants/global/data'
import { dateFormat, groupBy, sortData } from '../../constants/global/util'

export default {
  components: {
    pageButtons,
    borCor
  },
  mixins: [
    routeLoading,
    responsitive
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // data
      cases: [],
      selectedCaseIDs: [],
      disabledCaseIDs: [],
      // table
      query: '',
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [
        [
          50
        ],
        [
          62,
          62,
          134,
          134,
          115,
          124
        ]
      ],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // page
      displayPage: 1,
      pageData: {
        selectedPage: 1,
        display: 25,
        total: null,
        buttonRange: 7,
        pageJumpTo: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'userSetting'
    ]),
    filtedDatas () {
      let filtedDatas = this.cases
      const selectedCaseIDMap = this.param.selectedCases.reduce((map, caseData) => ({ ...map, [caseData.id]: caseData }), {})
      filtedDatas = filtedDatas.filter(data => data.case_id.includes(this.query) && !selectedCaseIDMap[data.id])
      return filtedDatas
    },
    tableFiltedDatas () {
      let tableFiltedDatas = this.filtedDatas
      tableFiltedDatas = sortData(
        tableFiltedDatas,
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      tableFiltedDatas = tableFiltedDatas.filter((data, index) => {
        let dataIndex = index - (this.displayPage - 1) * this.pageData.display
        return (dataIndex >= 0) && (dataIndex < this.pageData.display)
      })
      return tableFiltedDatas
    },
    tableDatas () {
      let tableDatas = this.tableFiltedDatas
      tableDatas = groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      return tableDatas
    },
    selectedCases () {
      const caseIDMap = this.cases.reduce((map, caseData) => ({ ...map, [caseData.id]: { id: caseData.id, case_id: caseData.case_id } }), {})
      return this.selectedCaseIDs.filter(id => caseIDMap[id]).map(id => caseIDMap[id])
    },
    allCaseDatas () {
      return this.filtedDatas.filter(caseData => !this.disabledCaseIDs.includes(caseData.id))
    },
    caseDatas () {
      return this.tableFiltedDatas.filter(caseData => !this.disabledCaseIDs.includes(caseData.id))
    },
    caseDataIDs () {
      return this.caseDatas.map(caseData => caseData.id)
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    sortValue () {
      return this.tableOptions.reduce((s, c) => ({ ...s, [c.value]: c.sortValue || c.value }), {})
    },
    totalPage () {
      return Math.ceil(Math.min(this.pageData.total, this.pageData.display * 5000) / this.pageData.display)
    },
    // static
    tableOptions () {
      return [
        {
          value: '_SELECT',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Case_ID'),
          value: 'case_id'
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Sex'),
          value: 'sex',
          class: () => ['center'],
          display: value => ({
            Male: this.$t('COMPONENT.caseList.single.table.display.sex.___Male'),
            Female: this.$t('COMPONENT.caseList.single.table.display.sex.___Female'),
            Unknown: this.$t('COMPONENT.caseList.single.table.display.sex.___Unknown')
          }[value]),
          style: value => ({ Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value])
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Age'),
          value: 'birth_year',
          class: () => ['center'],
          display: value => value ? ((new Date()).getFullYear() - value + '') : null
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Created_date'),
          value: 'created_at',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : null
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Modified_date'),
          value: 'updated_at',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : null
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Stage'),
          value: 'stage'
        },
        {
          title: this.$t('DIALOG.editWorkgroupCase.table.title.___Workgroup'),
          value: 'workgroup_name'
        }
      ]
    },
    // global
    pageDisplay () { return pageDisplay }
  },
  watch: {
    'query' (nv) {
      this.searchDatas(true)
    },
    'filtedDatas' (nv) {
      this.pageData.total = nv.length - 0
    },
    'pageData.selectedPage' () {
      if (this.pageData.selectedPage) {
        this.displayPage = this.pageData.selectedPage
        setTimeout(() => { this.pageData.selectedPage = 0 })
        this.searchDatas()
      }
    },
    // table
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    }
  },
  methods: {
    ...mapActions([
      'setModal2Action'
    ]),
    async fetchData () {
      await this.fetchCases(true)
    },
    async fetchCases (init = false) {
      try {
        let config = this.$ls.get('userInfo')
        let params = {
        }
        if (['supervisor'].includes(this.user.role) && (this.param.workgroup.user.user_id !== this.user.user_id)) {
          params.user_id = this.param.workgroup.user.user_id
        }
        let response = await getWorkgroupCases(params, config)
        let cases = response.data.data
        this.disabledCaseIDs = cases.filter(caseData => caseData.workgroup_name).map(caseData => caseData.id)
        this.cases = cases
        return this.cases
      } catch (error) {
        if (init) {
          throw error
        } else {
          this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        }
      }
    },
    async searchDatas (reset = false) {
      // this.setLoadingAction(true)
      reset && (this.displayPage = 1)
      // await this.fetchCases()
      // this.setLoadingAction(false)
    },
    addAllCase () {
      if (
        !this.param.result['auto_share_cases_to_workgroup'] &&
        !(this.userSetting.auto_share_cases_to_workgroup && (this.userSetting.auto_share_cases_to_workgroup !== this.param.workgroup.id))
      ) {
        this.setModal2Action({
          action: 'toast',
          width: '496px',
          customStyles: {
            padding: 0,
            border: 0
          },
          param: {
            type: 'normal',
            content: this.$t('DIALOG.editWorkgroupCase.modal.content.___checkAutoShare'),
            buttons: [
              {
                title: this.$t('COMMON.button.___yes'),
                type: 'main',
                result: true
              },
              {
                title: this.$t('COMMON.button.___no'),
                type: 'gray',
                result: false
              }
            ]
          },
          callback: async result => {
            this.$emit('changeModal', {}, { datas: this.allCaseDatas, autoShare: !!result })
          }
        })
      } else {
        this.$emit('changeModal', {}, { datas: this.allCaseDatas })
      }
    },
    // table
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      let tableWidth = Math.min(912, windowWidth * 0.95) - (22 * 2)
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        192,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableWidths = tableWidths
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editWorkgroupCase.vue